import _ from 'lodash';
import Highcharts from 'highcharts';
import { getTopGroups } from './utils';

function patientsByGroupDateGraph(adapter) {
  return {
    scope: {
      group: '=',
      groupType: '@',
      type: '@',
      top: '@'
    },
    template: '<div loading="loading" class="graph"></div>',
    link: function(scope, element) {
      scope.loading = true;

      scope.$watch('group', function(group) {
        var params = {groupType: scope.groupType};

        if (group) {
          params.group = group.id;
        }

        var title = scope.type === 'new' ? 'New Patients' : 'Total Patients';
        var key = scope.type === 'new' ? 'newPatients' : 'totalPatients';

        adapter.get('/stats/patients-by-group-date', params).then(function(response) {
          scope.loading = false;

          var options = {
            chart: {
              renderTo: element.get(0),
              type: 'spline',
              zoomType: 'x',
              height: 600
            },
            title: {
              text: title
            },
            xAxis: {
              type: 'datetime'
            },
            yAxis: {
              title: {
                text: 'Patients'
              },
              min: 0
            },
            series: [],
            plotOptions: {
              spline: {
                marker: {
                  enabled: false
                }
              }
            }
          };

          var n = parseInt(scope.top);
          var isVisible;

          if (n) {
            var topGroups = getTopGroups(response.data, n);

            isVisible = function(group) {
              return _.includes(topGroups, group.id);
            };
          } else {
            isVisible = function() {
              return true;
            };
          }

          var data = _.sortBy(response.data, 'group.name');

          _.forEach(data, function(group) {
            var series = {
              name: group.group.name,
              data: [],
              visible: isVisible(group.group)
            };

            options.series.push(series);

            _.forEach(group.counts, function(count) {
              series.data.push([Date.parse(count.date), count[key]]);
            });
          });

          new Highcharts.Chart(options);
        });
      });

    }
  };
}

patientsByGroupDateGraph.$inject = ['adapter'];

export default patientsByGroupDateGraph;



/** WEBPACK FOOTER **
 ** ./src/app/stats/patients-by-group-date-graph.directive.js
 **/